
<mat-dialog-content>
  <div class="col-xs-12 no-padder full-width-typeahead">
    <input class="form-control input-lg" type="text" placeholder="Search Team" aria-label="Number" name="question" autocomplete="off" matInput="matInput" style="border-radius:30px" [formControl]="autoCompleteController" [matAutocomplete]="auto"/>
    <mat-autocomplete class="search-bar-xs" #auto="matAutocomplete">
      <mat-option *ngFor="let option of options | async" [value]="option.name" (onSelectionChange)="autoCompleteOnSelect(option)">{{option.name}}</mat-option>
    </mat-autocomplete>
  </div>
</mat-dialog-content>